import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { QUERY_PEDAGOGIES } from '../../graphql/query/pedagogie/pedagogiesAll';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { MESSAGES } from '../../helpers/messages';
import { AllPedagogiesAndTypesQuery } from '../../graphql/generated/graphql';
import { RessourcesTypeContainer } from 'components/molecules/Containers/RessourcesTypeContainer';
import { getPedagogiesTypesFromQuery } from '../../helpers/transformApiResponse/pedagogies';

const Pedagogies = () => {
  const { loading, error, data } = useQuery<AllPedagogiesAndTypesQuery>(
    QUERY_PEDAGOGIES
  );
  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new ApolloError({
            extraInfo: error,
            errorMessage: 'error query PedagogiesAllByTypes'
          })
        }
        text={MESSAGES.error.pedagogie}
      />
    );
  const pedagogietypes = getPedagogiesTypesFromQuery(
    data.findPedagogieTypeWithRelatedPedagogies
  );

  return (
    <RessourcesTypeContainer ressourcesType={pedagogietypes} variant="blue" />
  );
};

export default Pedagogies;
